import React, { useContext } from 'react'
import { MdAir, MdHandyman } from 'react-icons/md'
import { GiHairStrands, GiMagicBroom, GiPartyPopper, GiFoodTruck, GiFamilyHouse, GiPaintRoller, GiReceiveMoney } from 'react-icons/gi'
import { IoBody } from 'react-icons/io5'
import Link from 'next/link'
import { LocationContext } from '../../context/LocationContext'

export const ServiceList = () => {

    const { countryCd, locality, countryName } = useContext(LocationContext)

  return (
    <div id="service-list" className='max-w-6xl mx-auto pt-5'>
        <h2 className="text-lg uppercase font-bold text-gray-500 px-2 py-4 text-center">Services in {countryName}</h2>
        <div className="text-center grid grid-cols-2 md:grid-cols-5 gap-8 px-2 py-4">
                {countryCd === "sg" ?
                    <Link href={`/${countryCd}/aircon-servicing-singapore`} prefetch={false} className=' text-orange-600 text-sm'>
                            <div className="space-y-1">
                                <div className='flex justify-center items-center'>
                                    <MdAir className='text-3xl'/>
                                </div>                       
                                <p>Aircon</p>	
                                <p className="text-2xs text-gray-500"><i>Get your aircon serviced</i></p>
                            </div>  
                    </Link>
                    :
                    <Link href={`/services/${countryCd}?requestType=${encodeURIComponent("Aircon Services")}`} prefetch={false} className=' text-orange-600 text-sm'>
                            <div className="space-y-1">
                                <div className='flex justify-center items-center'>
                                    <MdAir className='text-3xl'/>
                                </div>                       
                                <p>Aircon</p>	
                                <p className="text-2xs text-gray-500"><i>Get your aircon serviced</i></p>
                            </div> 
                    </Link>
                }
                
                {(countryCd === "sg" || countryCd === "us") ?
                    <Link href={`/${countryCd}/personal-trainer`} prefetch={false} className='text-orange-600 text-sm'>
                            <div className="space-y-1">
                                <div className='flex justify-center'>
                                    <IoBody className='text-3xl'/>
                                </div>                            
                                <p>Personal Trainer</p>
                                <p className="text-2xs text-gray-500"><i>Get a fitness deal and stay fit</i></p>	
                            </div>
                    </Link>
                    :                     
                    <Link href={`/services/${countryCd}?requestType=${encodeURIComponent("Fitness Trainer")}`} prefetch={false} className='text-orange-600 text-sm'>
                            <div className="space-y-1">
                                <div className='flex justify-center'>
                                    <IoBody className='text-3xl'/>
                                </div>                            
                                <p>Personal Trainer</p>
                                <p className="text-2xs text-gray-500"><i>Get a fitness deal and stay fit</i></p>	
                            </div>	
                    </Link>
                }
                {countryCd === "sg" ?
                    <Link href={`/${countryCd}/handyman-singapore-services`} prefetch={false} className=' text-orange-600 text-sm'>
                            <div className="space-y-1">
                                <div className='flex justify-center'>
                                    <MdHandyman className='text-3xl'/>
                                </div>                            
                                <p>Handyman</p>	
                                <p className="text-2xs text-gray-500"><i>Get a handyman to fix it</i></p>
                            </div>
                    </Link>
                    :
                    <Link href={`/services/${countryCd}?requestType=${encodeURIComponent("Handyman Services")}`} prefetch={false} className=' text-orange-600 text-sm'>
                            <div className="space-y-1">
                                <div className='flex justify-center'>
                                    <MdHandyman className='text-3xl'/>
                                </div>                            
                                <p>Handyman</p>	
                                <p className="text-2xs text-gray-500"><i>Get a handyman to fix it</i></p>
                            </div>	
                    </Link>
                }
                {countryCd === "sg" ? 
                    <Link href={`/${countryCd}/part-time-cleaner-singapore`} prefetch={false} className='text-orange-600 text-sm'>
                            <div className="space-y-1">
                                <div className='flex justify-center'>
                                    <GiMagicBroom className='text-3xl'/>
                                </div>                            
                                <p>Helper</p>	
                                <p className="text-2xs text-gray-500"><i>Get a part-time helper</i></p>
                            </div>
                    </Link>
                    :
                    <Link href= {`/services/${countryCd}?requestType=${encodeURIComponent("Domestic Services")}`} prefetch={false} className='text-orange-600 text-sm'>
                            <div className="space-y-1">
                                <div className='flex justify-center'>
                                    <GiMagicBroom className='text-3xl'/>
                                </div>                            
                                <p>Domestic</p>	
                                <p className="text-2xs text-gray-500"><i>Get a part-time helper</i></p>
                            </div>
                    </Link>
                }
                
                <Link href={`/services/${countryCd}?requestType=${encodeURIComponent("Beauty Services")}`}
                    prefetch={false} className=' text-orange-600 text-sm'>
                        <div className="space-y-1">
                            <div className='flex justify-center'>
                                <GiHairStrands className='text-3xl'/>
                            </div>                            
                            <p>Beauty</p>	
                            <p className="text-2xs text-gray-500"><i>Pamper yourself with a beauty service</i></p>
                        </div>
                </Link>
                {countryCd === "sg" ?
                    <Link href={`/${countryCd}/property-agent`} prefetch={false} className=' text-orange-600 text-sm'>
                            <div className="space-y-1">
                                <div className='flex justify-center'>
                                    <GiFamilyHouse className='text-3xl'/>
                                </div>                            
                                <p>Housing</p>	
                                <p className="text-2xs text-gray-500"><i>Rent, buy or sale a property</i></p>
                            </div>
                    </Link>
                    :
                    <Link href={`/services/${countryCd}?requestType=${encodeURIComponent("Housing")}`} prefetch={false} className=' text-orange-600 text-sm'>
                            <div className="space-y-1">
                                <div className='flex justify-center'>
                                    <GiFamilyHouse className='text-3xl'/>
                                </div>                            
                                <p>Housing</p>	
                                <p className="text-2xs text-gray-500"><i>Rent, buy or sale a property</i></p>
                            </div>
                    </Link>
                }
                {countryCd === "sg" ?
                    <Link href={`/${countryCd}/financial-adviser-singapore`} prefetch={false} className=' text-orange-600 text-sm'>
                            <div className="space-y-1">
                                <div className='flex justify-center'>
                                    <GiReceiveMoney className='text-3xl'/>
                                </div>                            
                                <p>Financial Advisor</p>	
                                <p className="text-2xs text-gray-500"><i>Health & financial planning</i></p>
                            </div>
                    </Link>
                    :
                    <Link href={`/services/${countryCd}?requestType=${encodeURIComponent("Financial")}`} prefetch={false} className=' text-orange-600 text-sm'>
                            <div className="space-y-1">
                                <div className='flex justify-center'>
                                    <GiReceiveMoney className='text-3xl'/>
                                </div>                            
                                <p>Financial Advisor</p>	
                                <p className="text-2xs text-gray-500"><i>Health & financial planning</i></p>
                            </div>
                    </Link>
                }
                <Link href={`/services/${countryCd}?requestType=${encodeURIComponent("Food Catering")}`}
                    prefetch={false} className='text-orange-600 text-sm'>
                        <div className="space-y-1">
                            <div className='flex justify-center'>
                                <GiFoodTruck className='text-3xl'/>
                            </div>                            
                            <p>Catering</p>	
                            <p className="text-2xs text-gray-500"><i>Get yummy food from your nearest caterer</i></p>
                        </div>	
                </Link>
                <Link href={`/services/${countryCd}?requestType=${encodeURIComponent("Event Planning")}`}
                    prefetch={false} className='text-orange-600 text-sm'>
                        <div className="space-y-1">
                            <div className='flex justify-center'>
                                <GiPartyPopper className='text-3xl'/>
                            </div>                            
                            <p>Event</p>	
                            <p className="text-2xs text-gray-500"><i>Get an event planner</i></p>
                        </div>
                </Link>
                <Link href={`/services/${countryCd}?requestType=${encodeURIComponent("Interior Designing")}`}
                    prefetch={false} className='text-orange-600 text-sm'>
                        <div className="space-y-1">
                            <div className='flex justify-center'>
                                <GiPaintRoller className='text-3xl'/>
                            </div>                            
                            <p>Interior</p>	
                            <p className="text-2xs text-gray-500"><i>Give a new look to your home or office</i></p>
                        </div>	
                </Link>  
        </div>
    </div>
  )
}
